import fontControlInit from "../components/fontSizeControl";
import onceModalInit from "../components/onceModal";
import termsInit from "./components/acceptTermsModal";
import { initializeTrayIcon, updateTrayIcon } from "./components/mailbox";

/**
 * Script que se incluye en el template de forma que está en todas las páginas.
 */
$(() => {
  /* Escala de la fuente */
  fontControlInit("ims-a-decrease-text", "ims-a-enlarge-text");

  /* Icono bandeja de entrada. */
  initializeTrayIcon();

  /* Modal de bienvenida. Si existe, se muestra la primera vez por visita. */
  onceModalInit();

  /* Modal de condiciones */
  termsInit();
});

/* Métodos publicados para acceder desde js y html.
 * Actualmente sirve de interacción con la parte vieja. */
// TODO: Definir interfaz
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).ImsTemplate = {
  updateTrayIcon: (unread: number) => {
    /* Esto está publicado y se puede acceder desde js viejo y html. Hay que
     * validar que lo que entra está bien. */
    if (typeof unread === "number") {
      updateTrayIcon(unread);
    }
  },
};
